import { AxiosInstance } from 'axios';
import {
  getPaynowStatusResponse,
  PostGeneratePaynowQRResponse,
  PostUpdateTransactionNumberRequest,
  PostUpdateTransactionNumberResponse,
  ValidateLinkRequest,
  ValidateLinkResponse,
} from './model';
import * as ROUTE from './route';
import { axiosFactory } from '../client';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/financial/api`;
const timeout = 5000;

export const financialClient = axiosFactory(baseURL, timeout);

export const financialTestClient = (financialClient as unknown) as AxiosInstance;

/**
 * To validate Unique Link
 *
 * @param csrfToken
 * @param validateLink
 */
const postValidateUniqueLink = (csrfToken: string, validateLink: ValidateLinkRequest) =>
  financialClient.post<ValidateLinkResponse>(
    csrfToken,
    `${ROUTE.POST_VALIDATE_UNIQUE_LINK}`,
    validateLink
  );

const postPaymentOffline = (csrfToken: string, merchantTxnId: string) =>
  financialClient.post(csrfToken, `${ROUTE.POST_OFFLINE}/${merchantTxnId}`);

const postGeneratePaynowQR = (csrfToken: string, merchantTxnId: string) =>
  financialClient.post<PostGeneratePaynowQRResponse>(
    csrfToken,
    `${ROUTE.POST_GENERATE_PAYNOW_QR}/${merchantTxnId}`
  );

const getPaynowStatus = (merchantTxnId: string) =>
  financialClient.get<getPaynowStatusResponse>(`${ROUTE.GET_PAYNOW_STATUS}/${merchantTxnId}`);

// TODO - sevin: remove this API
const postTransactionCreate = (
  csrfToken: string,
  requestBody: { applicationType: string; transactionAmount: number }
) =>
  financialClient.post<{ internalTransactionRef: string }>(
    csrfToken,
    '/transaction/create',
    requestBody
  );

const postUpdateTransactionNumber = (
  csrfToken: string,
  requestBody: PostUpdateTransactionNumberRequest
) =>
  financialClient.post<PostUpdateTransactionNumberResponse>(
    csrfToken,
    ROUTE.POST_UPDATE_TRANSACTION_NUMBER,
    requestBody
  );

export {
  postValidateUniqueLink,
  postPaymentOffline,
  postGeneratePaynowQR,
  getPaynowStatus,
  postTransactionCreate,
  postUpdateTransactionNumber,
};
